import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from 'utils/Functions/ProtectedRoute';
import ViewLanguage from 'views/Language/ViewLanguage';
import ViewFeedback from 'views/Feedback/ViewFeedback';

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// dashboard routing
const DashBoardpage = Loadable(lazy(() => import('views/dashboard')));

// user pages
const UserList = Loadable(lazy(() => import('views/User/UserList')));
const Interest = Loadable(lazy(() => import('views/User/Interest')));
const UserStatistics = Loadable(lazy(() => import('views/User/UserStatistics')));
const Category = Loadable(lazy(() => import('views/User/UserCategory')));
const UserDetails = Loadable(lazy(() => import('views/User/userDetails/userDetails')));

// university pages
const ViewUniversity = Loadable(lazy(() => import('views/Universities/ViewUniversity')));

// notifications pages
const ViewNotifications = Loadable(lazy(() => import('views/Notifications/ViewNotifications')));

// Course & skill pages
const ViewCourse = Loadable(lazy(() => import('views/SkillAndCource/ViewCourse')));
const ViewSkill = Loadable(lazy(() => import('views/SkillAndCource/ViewSkill')));
const ViewEvents = Loadable(lazy(() => import('views/Events/ViewEvents')));
const ViewJobs = Loadable(lazy(() => import('views/Jobs/ViewJobs')));

// prompts pages
const ViewPrompts = Loadable(lazy(() => import('views/Prompts/ViewPrompts')));

// industry pages
const ViewIndustry = Loadable(lazy(() => import('views/Industry/ViewIndustry')));

// question pages
const ViewQuestion = Loadable(lazy(() => import('views/Question/ViewQuestion')));

// geography pages
const Country = Loadable(lazy(() => import('views/Geography/Country/Country')));
const State = Loadable(lazy(() => import('views/Geography/State/State')));
const City = Loadable(lazy(() => import('views/Geography/City/City')));

// user edit
const UserEdit = Loadable(lazy(() => import('views/User/UserEdit')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <ProtectedRoute>
            <MainLayout />
        </ProtectedRoute>
    ),
    children: [
        {
            path: '/user',
            element: (
                <ProtectedRoute>
                    <UserList />
                </ProtectedRoute>
            )
        },
        {
            path: '/interest',
            element: (
                <ProtectedRoute>
                    <Interest />
                </ProtectedRoute>
            )
        },
        {
            path: '/user-statistics',
            element: (
                <ProtectedRoute>
                    <UserStatistics />
                </ProtectedRoute>
            )
        },
        {
            path: '/categories',
            element: (
                <ProtectedRoute>
                    <Category />
                </ProtectedRoute>
            )
        },
        {
            path: '/',
            element: (
                <ProtectedRoute>
                    <DashBoardpage />
                </ProtectedRoute>
            )
        },
        {
            path: '/utils/util-typography',
            element: (
                <ProtectedRoute>
                    <UtilsTypography />
                </ProtectedRoute>
            )
        },
        {
            path: '/utils/util-color',
            element: (
                <ProtectedRoute>
                    <UtilsColor />
                </ProtectedRoute>
            )
        },
        {
            path: '/utils/util-shadow',
            element: (
                <ProtectedRoute>
                    <UtilsShadow />
                </ProtectedRoute>
            )
        },
        {
            path: '/icons/tabler-icons',
            element: (
                <ProtectedRoute>
                    <UtilsTablerIcons />
                </ProtectedRoute>
            )
        },
        {
            path: '/icons/material-icons',
            element: (
                <ProtectedRoute>
                    <UtilsMaterialIcons />
                </ProtectedRoute>
            )
        },
        {
            path: '/sample-page',
            element: (
                <ProtectedRoute>
                    <SamplePage />
                </ProtectedRoute>
            )
        },
        {
            path: '/user/:userId',
            element: (
                <ProtectedRoute>
                    <UserDetails />
                </ProtectedRoute>
            )
        },
        {
            path: '/universities/View',
            element: (
                <ProtectedRoute>
                    <ViewUniversity />
                </ProtectedRoute>
            )
        },
        {
            path: '/notifications/View',
            element: (
                <ProtectedRoute>
                    <ViewNotifications />
                </ProtectedRoute>
            )
        },
        {
            path: '/course/view',
            element: (
                <ProtectedRoute>
                    <ViewCourse />
                </ProtectedRoute>
            )
        },
        {
            path: '/skill/view',
            element: (
                <ProtectedRoute>
                    <ViewSkill />
                </ProtectedRoute>
            )
        },
        {
            path: '/events/view',
            element: (
                <ProtectedRoute>
                    <ViewEvents />
                </ProtectedRoute>
            )
        },
        {
            path: '/jobs/view',
            element: (
                <ProtectedRoute>
                    <ViewJobs />
                </ProtectedRoute>
            )
        },
        {
            path: '/prompts/view',
            element: (
                <ProtectedRoute>
                    <ViewPrompts />
                </ProtectedRoute>
            )
        },
        {
            path: '/industries/View',
            element: (
                <ProtectedRoute>
                    <ViewIndustry />
                </ProtectedRoute>
            )
        },

        {
            path: '/question/view',
            element: (
                <ProtectedRoute>
                    <ViewQuestion />
                </ProtectedRoute>
            )
        },
        {
            path: '/country/view',
            element: (
                <ProtectedRoute>
                    <Country />
                </ProtectedRoute>
            )
        },
        {
            path: '/state/view',
            element: (
                <ProtectedRoute>
                    <State />
                </ProtectedRoute>
            )
        },
        {
            path: '/city/view',
            element: (
                <ProtectedRoute>
                    <City />
                </ProtectedRoute>
            )
        },
        {
            path: '/edit/:userId',
            element: (
                <ProtectedRoute>
                    <UserEdit />
                </ProtectedRoute>
            )
        },
        {
            path: '/language/view',
            element: (
                <ProtectedRoute>
                    <ViewLanguage />
                </ProtectedRoute>
            )
        },
        {
            path: '/feedback/view',
            element: (
                <ProtectedRoute>
                    <ViewFeedback />
                </ProtectedRoute>
            )
        },
    ]
};

export default MainRoutes;
